module.exports = __webpack_public_path__ + "img/credit-card.9ea91b17.png";